import { DATE_FORMATS } from '../../../../constants';

import templateUrl from './usersImportTableComponent.html';

class UsersImportTableCtrl {
  constructor(PersonaCollection, Authentication, $scope) {
    'ngInject';

    Object.assign(this, { PersonaCollection, Authentication, $scope });
  }

  $onInit() {
    this.options = [
      { value: 'name', label: 'First name' },
      { value: 'lastname', label: 'Last name' },
      { value: 'fullName', label: 'Full name' },
      { value: 'employeeId', label: 'Employee ID' },
      { value: 'email', label: 'Email' },
      { value: 'phone', label: 'Phone' },
      { value: 'location', label: 'Location' },
      { value: 'position', label: 'Position' },
      { value: 'group', label: 'Group' },
      {
        value: 'hireDate',
        label: 'Hire date',
        submenu: this.getAllDateOptions('hireDate', 'Hire date'),
      },
      { value: 'kioskPin', label: 'Kiosk PIN' },
      { value: 'hoursCap', label: 'Preferred hours per week' },
    ];

    if (this.Authentication.isOrgFeatureEnabled('laborCost')) {
      this.options.push({
        value: 'wage',
        label: 'Base hourly rate',
      });
    }
  }

  getAllDateOptions(fieldType, fieldLabel) {
    return Object.entries(DATE_FORMATS).map(([format, example]) => ({
      label: example,
      toggleLabel: `${fieldLabel} (${example})`,
      value: [fieldType, format],
    }));
  }

  $onChanges({ rows }) {
    if (rows && rows?.currentValue?.[0]) {
      this.selectedColumns = {};
      this.rows[0].cells.forEach((cell, index) => {
        this.selectedColumns[index] = true;
      });
    }
  }

  getRowSize() {
    const MODAL_WIDTH = 1024;
    const COL_MIN_WIDTH = 150;
    const STICKY_COL_WIDTH = 58;

    const flexWidth = (MODAL_WIDTH - STICKY_COL_WIDTH) / this.rows.length;
    return Math.max(flexWidth, COL_MIN_WIDTH);
  }

  get selectedAll() {
    return this.selectedColumns && Object.values(this.selectedColumns).every(Boolean);
  }

  set selectedAll(val) {
    if (this.selectedColumns) {
      Object.keys(this.selectedColumns).forEach((key) => {
        this.selectedColumns[key] = val;
      });
    }
  }

  columnCheckedClick(index, event) {
    if (event.target.tagName === 'INPUT') {
      this.onRowSelectChange?.();
      if (
        (event.metaKey || event.ctrlKey) &&
        this.selectedColumns[index] === this.lastColumnChecked?.[1]
      ) {
        for (
          let i = Math.min(index, this.lastColumnChecked[0]);
          i <= Math.max(index, this.lastColumnChecked[0]);
          i++
        ) {
          this.selectedColumns[i] = this.selectedColumns[index];
        }
      }

      this.lastColumnChecked = [index, this.selectedColumns[index]];
    }
  }
}

export default {
  templateUrl,
  controllerAs: 'ctrl',
  controller: UsersImportTableCtrl,
  bindings: {
    rows: '<',
    onColTypeChange: '&?',
    onRowSelectChange: '&?',
    selectedColumns: '=?',
  },
};
